@if(!browserInited) { <bs5-placeholder-form [rows]="4" [cols]="2" /> } @else {
<div class="modal-header">
    <h4 class="modal-title">
        <i class="fa-solid fa-clipboard-check me-1"></i> {{ title || '출고요청 검증 결과' }}
    </h4>
    <div class="d-flex gap-1">
        <!-- 모달 드래그 이동 -->
        @if (modalCtrl.opts.drag) {
        <button type="button" class="btn btn-light btn-sm" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle
            [disabled]="modalCtrl.state.fullscreen">
            <i class="fa-solid fa-arrows-up-down-left-right"></i>
        </button>
        }
        <!-- 모달 닫기 -->
        <button type="button" class="btn btn-light btn-sm" (click)="modalCtrl.activeModal.dismiss()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
</div>
<div class="modal-body d-flex flex-column gap-2" style="height: 360px;">
    <!-- 요약: 오류가 있으면 출고할 수 없다 -->
    <div class="d-flex align-items-center gap-2">
        @if (checkResults.length === 0) {
        <span class="badge border bg-success-subtle text-success-emphasis border-success-subtle fs-6">문제 없음</span>
        } @else {
        <span class="badge border bg-danger-subtle text-danger-emphasis border-danger-subtle fs-6">오류 {{ errorCnt }}</span>
        <span class="badge border bg-warning-subtle text-warning-emphasis border-warning-subtle fs-6">주의 {{ alertCnt }}</span>
        @if (errorCnt > 0) { <span class="text-danger small">오류가 있으면 출고할 수 없습니다.</span> }
        }    </div>
    <div class="np-flex-grid-theme-3 d-flex flex-column np-flex-h100">
        <np-flex-grid-menu #flexGrid1Menu [flexGridCtrl]="flexGrid1Ctrl"></np-flex-grid-menu>
        <wj-flex-grid #flexGrid1 (initialized)="flexGrid1Ctrl.init(flexGrid1)" [itemsSource]="flexGrid1Cv"
            [allowSorting]="'MultiColumn'" [selectionMode]="'MultiRange'" [showSelectedHeaders]="'All'"
            [frozenColumns]="0" [isReadOnly]="true" [imeEnabled]="true">

            <ng-template wjFlexGridCellTemplate [cellTypeStr]="'TopLeft'">
                <span class="np-flex-grid-menu-icon" (click)="flexGrid1Menu.toggle($event)"></span>
            </ng-template>

            <ng-template wjFlexGridCellTemplate [cellTypeStr]="'RowHeader'" let-row="row">
                {{ row.index + 1 }}
            </ng-template>

            <wj-flex-grid-column [header]="'수준'" [binding]="'type'" [width]="70" [align]="'center'"
                [dataMap]="dataMap.type">
                <ng-template wjFlexGridCellTemplate [cellTypeStr]="'Cell'" let-item="item">
                    <span class="badge border" [ngClass]="typeBadgeClass(item.type)">
                        {{ item.type === 'ERROR' ? '오류' : '주의' }}</span>
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'분류'" [binding]="'category'" [width]="90" [align]="'center'"
                [dataMap]="dataMap.category" />
            <wj-flex-grid-column [header]="'메시지'" [binding]="'message'" [width]="'*'" />

            <wj-flex-grid-filter #flexGrid1Filter />
        </wj-flex-grid>

        <!-- 조회 결과가 없을 때 안내 -->
        @if (!$any(flexGrid1Cv).isLoading && $any(flexGrid1Cv).totalItemCount === 0) {
        <div class="np-grid-empty">
            <i class="fa-regular fa-folder-open"></i>
            <div class="np-grid-empty-title">조회 결과가 없습니다</div>
        </div>
        }
    </div>
</div>
<div class="modal-footer">
    <div class="d-flex gap-2">
        <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">닫기</button>
    </div>
</div>
}
